import { useSelector } from 'store/store'
import { SectionCard, Select, Input } from 'components'

import * as S from './styles'

export const CancelSection = () => {
  const { observation } = useSelector((state) => state.ov)

  return (
    <SectionCard
      title="Informações de cancelamento"
      tooltipText="Nesta seção você pode conferir o motivo, bem como uma descrição complementar, da razão de cancelamento da sua OV. Podendo ele ter sido, ou não, executado por você."
    >
      <S.Wrapper>
        <Select
          name="cancelReason"
          label="Motivo"
          value={'reason'}
          options={[
            { title: observation.RecusaObservacao.DescricaoMotivo, value: 'reason' }
          ]}
          required
          disabled
        />
        <div>
          <Input
            name="cancelDescription"
            label="Descrição"
            value={observation.RecusaObservacao.Comentarios}
            required
            disabled
            rows={3}
          />
        </div>
      </S.Wrapper>
    </SectionCard>
  )
}
